module.exports = __webpack_public_path__ + "img/errorpagenotfound.b715a61.webp";